import React, { useState, useEffect } from 'react';
import GlobalNav from '../components/GlobalNav';
import Footer from '../components/Footer';
import './EpkUpdate.css';

export default function EpkUpdate() {
  const [user, setUser] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [toast, setToast] = useState(false);
  const secretToken = window.location.pathname.split('/').pop();

  useEffect(() => {
    // This page edits a specific profile via secretToken — legitimately
    // gated, unlike the public Epk.jsx view.
    const stored = localStorage.getItem('user');
    if (!stored) {
      window.location.href = '/signin?redirect=/hub';
      return;
    }
    try {
      JSON.parse(stored);
    } catch (e) {
      localStorage.removeItem('user');
      window.location.href = '/signin';
      return;
    }

    async function fetchProfile() {
      try {
        const res = await fetch(`/api/artist-profile-complete/${secretToken}`);
        const data = await res.json();
        if (data.success) {
          setUser(data.user);
        } else {
          setError(data.error || 'Profile not found');
        }
      } catch (err) {
        console.error(err);
        setError('Error loading profile');
      }
    }
    fetchProfile();
  }, [secretToken]);

  function handleChange(e) {
    setUser((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSave() {
    setSaving(true);
    setError('');
    try {
      const res = await fetch('/api/update-epk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user),
      });
      const data = await res.json();
      if (data.success) {
        setToast(true);
        setTimeout(() => { window.location.href = '/profile'; }, 2000);
      } else {
        setError(data.error || 'Update failed.');
      }
    } catch (err) {
      console.error(err);
      setError('Network error saving profile');
    } finally {
      setSaving(false);
    }
  }

  if (error && !user) {
    return (
      <div className="epku-page">
        <GlobalNav activeHref="" />
        <div className="epku-body">
          <div className="epku-error">{error}</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="epku-page">
        <GlobalNav activeHref="" />
        <div className="epku-loading">
          <div className="epku-spinner" />
          <p>Loading profile…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="epku-page">
      <GlobalNav activeHref="" />

      <div className="epku-body">
        <div className="epku-panel">
          <h1 className="epku-title">Edit your artist profile</h1>

          <div className="epku-preview">
            <img
              className="epku-preview-avatar"
              src={user.photo || '/images/default-profile.png'}
              alt={user.artistName || user.firstname}
            />
            <div>
              <div className="epku-preview-name">{user.firstname} {user.lastname}</div>
              <div className="epku-preview-username">{user.username}</div>
            </div>
          </div>

          {error && <div className="epku-error">{error}</div>}

          <div className="epku-field">
            <label className="epku-label" htmlFor="artistName">Artist / band name</label>
            <input id="artistName" className="epku-input" type="text"
              name="artistName" value={user.artistName || ''} onChange={handleChange} />
          </div>

          <div className="epku-field">
            <label className="epku-label" htmlFor="official">Official website</label>
            <input id="official" className="epku-input" type="text"
              name="official" value={user.official || ''} onChange={handleChange} />
          </div>

          <div className="epku-field">
            <label className="epku-label" htmlFor="bio">Bio</label>
            <textarea id="bio" className="epku-input epku-textarea" rows={5}
              name="bio" value={user.bio || ''} onChange={handleChange} />
          </div>

          <div className="epku-field">
            <label className="epku-label" htmlFor="video">Featured video (embed URL)</label>
            <input id="video" className="epku-input" type="text"
              name="video" value={user.video || ''} onChange={handleChange} />
          </div>

          <div className="epku-divider" />

          <div className="epku-section-label">Audio samples</div>

          {[1, 2, 3].map((n) => (
            <div key={n} className="epku-audio-group">
              <input
                className="epku-input"
                placeholder={`Audio ${n} title`}
                name={`audio${n}Title`}
                value={user[`audio${n}Title`] || ''}
                onChange={handleChange}
              />
              <input
                className="epku-input"
                placeholder={`Audio ${n} URL`}
                name={`audio${n}`}
                value={user[`audio${n}`] || ''}
                onChange={handleChange}
              />
              {user[`audio${n}`] && (
                <audio controls className="epku-audio-preview">
                  <source src={user[`audio${n}`]} type="audio/mpeg" />
                </audio>
              )}
            </div>
          ))}

          <button className="mihu-btn-primary-lg epku-save" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving…' : 'Save changes'}
          </button>
        </div>
      </div>

      {toast && (
        <div className="epku-toast" role="status">Profile updated ✓</div>
      )}

      <Footer />
    </div>
  );
}
